<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8">
    <!-- هدر صفحه و دکمه افزودن -->
    <v-row class="mb-4 align-center">
      <v-col>
        <!-- <h2 class="font-weight-bold">مدیریت تنوع‌های محصول</h2> -->
        <p class="grey--text mt-1">
          شما در این بخش می‌توانید تنوع‌های مختلف (SKU) برای محصول مورد نظر را مدیریت کنید.
        </p>
      </v-col>
      <v-col class="text-left">
        <v-btn class="btn-get-code rounded-lg" @click="openCreateDialog">
          <v-icon left>mdi-plus</v-icon>
          افزودن تنوع جدید
        </v-btn>
      </v-col>
    </v-row>

    <!-- جدول نمایش تنوع‌ها -->
    <vue-table
      :data="tableData"
      :headers="headers"
      :loading="loading"
      @change="onPagination"
    >
      <!-- فیلترهای بالای جدول -->
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters class="mb-4">
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select
              v-model="props.length"
              :items="perPage"
              label="تعداد در صفحه"
              outlined dense hide-details class="rounded-lg"
              @change="() => onPagination(props)"
            />
          </v-col>
             <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select
              v-model="props.dir"
              :items="sortDirections"
              item-text="text"
              item-value="value"
              label="ترتیب نمایش"
              outlined dense hide-details class="rounded-lg"
              @change="() => onPagination(props)"
            />
          </v-col>
          <v-col class="pa-2" cols="12" md="3">
            <v-text-field
              v-model="props.search"
              append-icon="mdi-magnify"
              label="جستجو در SKU یا عنوان..."
              outlined dense hide-details clearable
              class="rounded-lg"
              @keyup.enter="() => onPagination(props)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- نمایش ردیف -->
      <template v-slot:index="{ item }">
        {{ persian(item.index + 1 + (tableData.current_page - 1) * tableData.per_page) }}
      </template>
      
      <!-- نمایش ویژگی‌ها -->
      <template v-slot:attributes="{ item }">
        <div v-if="item.attributes && Object.keys(item.attributes).length" class="py-2 d-flex flex-wrap" style="gap: 6px;">
          <v-chip v-for="(attr, key) in item.attributes" :key="key" small label class="ma-0">
            <v-avatar v-if="key === 'رنگ'" left class="mr-n1 ml-1">
              <span class="color-box" :style="{ backgroundColor: getColorHex(attr.value) }"></span>
            </v-avatar>
            {{ attr.label }}: {{ attr.value }}
          </v-chip>
        </div>
        <span v-else class="grey--text text-caption">ندارد</span>
      </template>
      
      <!-- قیمت و موجودی -->
      <template v-slot:price_stock="{ item }">
        <div>
          <!-- <div class="font-weight-bold">{{ persian(item.base_price, true) }} تومان</div> -->
          <div class="text-caption grey--text">موجودی: {{ persian(item.stock) }} عدد</div>
        </div>
      </template>
      <!--title-->
      <template v-slot:title="{ item }">
         <div class="d-flex align-center">
          <v-avatar v-if="item?.main_image && item?.main_image?.url" size="40" rounded class="ml-2 grey lighten-4">
            <img :src="item?.main_image?.url" alt="product" />
          </v-avatar>
        <div>
          <div class="font-weight-bold my-2">{{item.title}}</div>
          <div class="grey--text mb-1">{{  `کد تنوع: ${item.sku} (${item.product_id})` }}</div>
        </div>
        </div>
      </template>

      
      <!-- وضعیت -->
      <template v-slot:is_active="{ item }">
        <v-switch
          v-model="item.is_active"
          color="success"
          dense hide-details inset
          @change="toggleActiveStatus(item)"
          :loading="item.loading"
          class="mt-0 pt-0"
        ></v-switch>
      </template>
      
      <!-- عملیات -->
      <template v-slot:action="{ item }">
        <div @click.stop.prevent @mousedown.stop.prevent>
          <action-buttons :data="item" :meta="metabuttons"/>
        </div>
      </template>

    </vue-table>

    <!-- دیالوگ افزودن/ویرایش تنوع -->
    <custom-popup v-model="dialog" :cons="{ title: dialogTitle,icon:'package-variant' }" max-width="850">
      <v-card flat>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container class="pa-6">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="editedItem.sku" label="کد تنوع (SKU)" :rules="[rules.required]" outlined dense />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="editedItem.title" label="عنوان تنوع" :rules="[rules.required]" outlined dense />
              </v-col>
              <!-- <v-col cols="12" md="6">
                <price-input v-model="editedItem.base_price" label="قیمت پایه" :rules="[rules.required, rules.minZero]" outlined dense />
              </v-col> -->
              <v-col cols="12" md="6">
                <v-text-field v-model.number="editedItem.stock" label="موجودی انبار" type="number" :rules="[rules.required, rules.minZero]" outlined dense />
              </v-col>
            </v-row>

            <v-divider class="my-5"></v-divider>
            <p class="font-weight-bold mb-3">ویژگی‌ها (رنگ، سایز، گارانتی و ...)</p>
            
            <div v-for="(attr, index) in tempAttributes" :key="index" class="d-flex align-start mb-3" style="gap: 8px;">
              <v-combobox
                v-model="attr.key"
                :items="predefinedAttributes.keys"
                label="نوع ویژگی"
                outlined dense hide-details class="flex-grow-1"
                @change="() => attr.value = ''"
              />
              <v-combobox
                v-model="attr.value"
                :items="predefinedAttributes.values[attr.key] || []"
                :label="`مقدار برای ${attr.key || 'ویژگی'}`"
                outlined dense hide-details class="flex-grow-2"
              />
              <v-text-field v-model="attr.label" label="برچسب فارسی" outlined dense hide-details class="flex-grow-1" />
              <v-btn icon class="btn-delete rounded-pill mt-1" @click="removeAttribute(index)" ><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
            </div>
            <v-btn small outlined class="btn-get-code" @click="addAttribute"><v-icon small left>mdi-plus</v-icon>افزودن ویژگی</v-btn>

            <v-divider class="my-5"></v-divider>
            <!-- <p class="font-weight-bold mb-3">فراداده (اختیاری)</p>
             <v-textarea
                v-model="editedItem.metadata"
                label="اطلاعات فراداده (فرمت JSON)"
                outlined rows="3" hint='مثال: {"note": "test1"}'
                class="ltr-input"
              ></v-textarea> -->

          </v-container>
        </v-form>
        <v-card-actions class="pa-4 grey lighten-4">
          <v-btn class="btn-delete rounded-lg" @click="closeDialog" ><v-icon small>mdi-close</v-icon>انصراف</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="btn-get-code rounded-lg px-8" :loading="saving" @click="saveSku"><v-icon small>mdi-plus</v-icon>ثبت</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import priceInput from "../../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
export default {
  name: "ProductSkusManager",
  components: { ActionButtons,priceInput },
  props: {
    productId: {
      type: [Number, String],
      required: true,
    },
      productSku: {
      type: String,
      default: 'SKU', 
    }
  },
  data() {
    return {
       sortDirections: [
        { text: 'جدیدترین', value: 'desc' },
        { text: 'قدیمی‌ترین', value: 'asc' },
      ],
      loading: false,
      saving: false,
      dialog: false,
      valid: true,
      
      tableData: { data: [], total: 0, current_page: 1, per_page: 10 },
      tableProps: { page: 1, length: 10, search: null, dir: 'desc', column: 'id'},
      
      headers: [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        // { text: "کد تنوع (SKU)", value: "sku", align: "start", sortable: true },
        { text: "عنوان / کد تنوع", value: "title", sortable: true },
        { text: "ویژگی‌ها", value: "attributes", sortable: false, width: "30%" },
        { text: "موجودی", value: "price_stock", sortable: false },
        { text: "وضعیت", value: "is_active", sortable: false },
        {text:"تعداد لیستینگ", value:"listings_count",sortable:false},
        { value: "action", text: "عملیات", align: "center", sortable: false },
      ],
      
      editedIndex: -1,
      editedItem: {
        sku: "", title: "",  stock: 0, is_active: true, attributes: {}, metadata: null,
      },
      defaultItem: {
        sku: "", title: "", stock: 0, is_active: true, attributes: {}, metadata: null,
      },

      tempAttributes: [],
      predefinedAttributes: {
        keys: ['رنگ', 'سایز', 'گارانتی'],
        values: {
          'رنگ': ['مشکی', 'سفید', 'قرمز', 'آبی', 'سبز', 'نقره‌ای', 'طلایی', 'رزگلد'],
          'سایز': ['S', 'M', 'L', 'XL', 'XXL', '38', '39', '40', '41', '42'],
          'گارانتی': ['۱۸ ماهه شرکتی', 'اصالت و سلامت فیزیکی', 'گارانتی ۱ ساله']
        }
      },

      colorMap: { "مشکی": "#212121", "سفید": "#FFFFFF", "قرمز": "#F44336", "آبی": "#2196F3", "سبز": "#4CAF50", "نقره‌ای": "#C0C0C0", "طلایی": "#FFD700", "رزگلد": "#B76E79" /* ...سایر رنگ‌ها */ },
      
      rules: {
        required: v => !!v || "این فیلد الزامی است.",
        minZero: v => (v !== null && v >= 0) || "مقدار نمی‌تواند منفی باشد.",
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.editedIndex === -1 ? "افزودن تنوع جدید" : "ویرایش تنوع";
    },
    metabuttons() {
      return {
        buttons: [
          { name: "edit", label: "ویرایش", icon: "pencil-outline", class: "btn-edit rounded-pill", action: this.openEditDialog, },
          { name: "delete", label: "حذف", icon: "trash-can-outline", class: "btn-delete rounded-pill", action: this.deleteSku, },
        ],
      };
    },
  },
  watch: {
    productId: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.fetchSkus();
      },
    },
  },
  methods: {
    async fetchSkus() {
      if (!this.productId) return;
      this.loading = true;
      try {
        const res = await this.$api.get(`/v1/products/${this.productId}/skus`, { params: this.tableProps });
        this.tableData = res.data.data;
        this.tableData.data.forEach(item => this.$set(item, 'loading', false));
      } catch (e) {
        this.$toast.error("خطا در دریافت لیست تنوع‌ها");
      } finally {
        this.loading = false;
      }
    },
    
    onPagination(e) {
      this.tableProps = { 
        ...this.tableProps, 
        ...e, 
        page: e.page || 1 
      };
      this.fetchSkus();
    },

    openCreateDialog() {
    const suggestedSku = `${this.productSku || 'SKU'}-VAR-${this.tableData.data.length + 1}`;
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem,sku: suggestedSku };
      this.tempAttributes = [];
      this.dialog = true;
      this.$nextTick(() => this.$refs.form?.resetValidation());
    },

    openEditDialog(item) {
      this.editedIndex = this.tableData.data.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      
      if (this.editedItem.metadata && typeof this.editedItem.metadata === 'object') {
        this.editedItem.metadata = JSON.stringify(this.editedItem.metadata, null, 2);
      }
      
      this.tempAttributes = this.editedItem.attributes 
        ? Object.entries(this.editedItem.attributes).map(([key, { label, value }]) => ({ key, label, value }))
        : [];

      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.tempAttributes = [];
        this.editedIndex = -1;
      });
    },

    addAttribute() {
      this.tempAttributes.push({ key: '', label: '', value: '' });
    },
    
    removeAttribute(index) {
      this.tempAttributes.splice(index, 1);
    },

    async saveSku() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      
      const attributes = this.tempAttributes.reduce((obj, attr) => {
        if (attr.key && attr.value) {
          obj[attr.key] = { value: attr.value, label: attr.label || attr.key };
        }
        return obj;
      }, {});
      
      let metadata = null;
      if (this.editedItem.metadata) {
        try {
          metadata = JSON.parse(this.editedItem.metadata);
        } catch (e) {
          this.$toast.error("فرمت فراداده (JSON) نامعتبر است.");
          this.saving = false;
          return;
        }
      }

      const payload = { ...this.editedItem, attributes, metadata };
      
      try {
        if (this.editedIndex > -1) {
          await this.$api.put(`/v1/products/${this.productId}/skus/${this.editedItem.id}`, payload);
          this.$toast.success("تنوع با موفقیت ویرایش شد.");
        } else {
          await this.$api.post(`/v1/products/${this.productId}/skus`, payload);
          this.$toast.success("تنوع با موفقیت ایجاد شد.");
        }
        this.closeDialog();
        await this.fetchSkus();
      } catch (e) {
        this.$toast.error(e.response?.data?.message || "خطا در ذخیره‌سازی اطلاعات");
      } finally {
        this.saving = false;
      }
    },

    async deleteSku(item) {
      console.log("here");
      if (await this.$modal.yesNo(`آیا از حذف تنوع "${item.title}" اطمینان دارید؟`)) {
        item.loading = true; 
        try {
          await this.$api.delete(`/v1/products/${this.productId}/skus/${item.id}`);
          this.$toast.success("تنوع با موفقیت حذف شد.");
          await this.fetchSkus();
        } catch (e) {
          this.$toast.error("خطا در حذف تنوع");
          item.loading = false;
        }
      }
    },

    async toggleActiveStatus(item) {
      item.loading = true;
      try {
        await this.$api.post(`/v1/products/${this.productId}/skus/${item.id}/toggle-active`);
        this.$toast.success("وضعیت تنوع با موفقیت تغییر کرد.");
      } catch (e) {
        this.$toast.error("خطا در تغییر وضعیت");
        item.is_active = !item.is_active; 
      } finally {
        item.loading = false;
      }
    },

    getColorHex(colorName) {
      if (!colorName) return '#D6D6D6';
      const cleanName = colorName.trim();
      return this.colorMap[cleanName] || '#D6D6D6'; // Fallback color
    },
  },
};
</script>

<style scoped>
.color-box {
  width: 14px;
  height: 14px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.ltr-input >>> textarea {
  direction: ltr;
  text-align: left;
}
</style>
